module.exports = __webpack_public_path__ + "img/cloud-solutions.26118fef.svg";